export const sessionRuleKeys = {
	all: ['session-rules'] as const,
	/** Every session rule the logged-in user can read. `scope` = tenant. */
	list: (scope: string) => [...sessionRuleKeys.all, 'list', scope] as const,
}
